import $ from "jquery"
import TemplateView from "../../TemplateView"
import WorkflowStatus from "../../workflowStatus/WorkflowStatus"
import SimpleTooltip from "../../SimpleTooltip"
import {getEnabledStatusMessageKeyByStatus} from "./utils"
import {enabledStatus} from "./constants"
import messageResource from "../../messageResource"
import {WorkflowStatusType} from '../../workflowStatus/constants'

export default class StatusRow extends TemplateView {
    constructor({
        id,
        onStatusClickCb = () => {},
        onDeleteClickCb = () => {}
    }) {
        super()

        this.id = id
        this.params = {
            id
        }

        this.state = {
            inEdit: false,
            name: '',
            colorId: 0,
            type: WorkflowStatusType.COMPLETED,
            enabledStatus: enabledStatus.ENABLED,
        }

        this.callbacks = {
            onStatusClickCb,
            onDeleteClickCb
        }

        this.onStatePropertyChanged('inEdit', () => this._setEditMode())
        this.onStatePropertyChanged('enabledStatus', () => this._setEnabledStatus())
        this.onAnyStatePropertyChanged(['name', 'type', 'colorId'], () => this._updateWorkflowStatusState())
    }

    templateHtml() {
        return "<div class='statusRow'>" +
               "        <div class='statusInfoContainer'>" +
               "            <div class='dragIcon'/>" +
               "            <div class='status'/>" +
               "            <div class='deleteIcon'/>" +
               "        </div>" +
               "    <div class='deleteStatusContainer'>" +
               "        <div class='innerContainer'>" +
               "            <div class='deleteMessage'><%-deleteConfirmationMessageFirstPart%> '<div class='statusName'><%-statusName%></div>' <%-deleteConfirmationMessageSecondPart%></div>" +
               "            <button class='confirmDelete'><%-confirmDeleteButtonText%></button>" +
               "            <div class='cancelDelete'><%-cancelDeleteButtonText%></div>" +
               "        </div>" +
               "    </div>"
    }

    templateModel() {
        return {
            statusName: this.state.name,
            deleteConfirmationMessageFirstPart: messageResource.getMessage('workflow_settings.delete_confirmation_message_first_part'),
            deleteConfirmationMessageSecondPart: messageResource.getMessage('workflow_settings.delete_confirmation_message_second_part'),
            confirmDeleteButtonText: messageResource.getMessage('workflow_settings.delete_confirm_button'),
            cancelDeleteButtonText: messageResource.getMessage('workflow_settings.delete_cancel_button'),
        }
    }

    _updateWorkflowStatusState() {
        this.status.setState({
            name: this.state.name,
            type: this.state.type,
            colorId: this.state.colorId,
        })
    }

    afterRender() {
        this.status = new WorkflowStatus({
            name: this.params.name,
            type: this.params.type,
            colorId: this.params.colorId,
            onClickCb: this.callbacks.onStatusClickCb,
        }).init(this.find('.status'))

        this._updateWorkflowStatusState()

        this.deleteIcon = this.find('.deleteIcon')
        this.deleteIcon.on('click', () => {
            if (this.state.enabledStatus === enabledStatus.ENABLED) {
                this._toggleConfirmDeleteDialog(true)
            }
        })

        this._setEnabledStatus()

        this.$statusInfoContainer = this.find('.statusInfoContainer')
        this.$deleteStatusContainer = this.find('.deleteStatusContainer')
        let confirmDeleteButton = this.find('.confirmDelete')
        confirmDeleteButton.on('click', () => {
            this.callbacks.onDeleteClickCb()
            this._toggleConfirmDeleteDialog(false)
        })
        let cancelDeleteButton = this.find('.cancelDelete')
        cancelDeleteButton.on('click', () => {
            this._toggleConfirmDeleteDialog(false)
        })
    }

    _toggleConfirmDeleteDialog = (inDeleting) => {
        this.$statusInfoContainer.toggle(!inDeleting)
        this.$deleteStatusContainer.toggle(inDeleting)
    }

    _setEditMode() {
        this.status.getEl().toggleClass('inEdit', this.state.inEdit)
    }

    _setEnabledStatus() {
        this.deleteIcon.toggleClass('disabled', this.state.enabledStatus !== enabledStatus.ENABLED)
        this.getTooltip().subscribeToMouseEvents(this.deleteIcon, () => {
            if (this.state.enabledStatus !== enabledStatus.ENABLED) {
                this.getTooltip().setText(messageResource.getMessage(getEnabledStatusMessageKeyByStatus(this.state.enabledStatus)))
                this.getTooltip().enable()
            } else {
                this.getTooltip().disable()
            }
        })
    }

    getTooltip() {
        if (!StatusRow.tooltip)
            StatusRow.tooltip = new SimpleTooltip().init($('body'))
        return StatusRow.tooltip
    }

    getDraggableEl() {
        return this.find('.dragIcon')
    }
}


// WEBPACK FOOTER //
// ./web/js/administration/workflowSettings/StatusRow.js